import _taggedTemplateLiteral from "/Users/diego.sampaio/olx/connecting/chat-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import { css } from 'styled-components';
export const withPaddings = _ref => {
  let {
    padding,
    paddingTop,
    paddingRight,
    paddingBottom,
    paddingLeft
  } = _ref;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n  "])), padding && "padding: var(".concat(padding, ");"), paddingTop && "padding-top: var(".concat(paddingTop, ");"), paddingRight && "padding-right: var(".concat(paddingRight, ");"), paddingBottom && "padding-bottom: var(".concat(paddingBottom, ");"), paddingLeft && "padding-left: var(".concat(paddingLeft, ");"));
};